import React, { useEffect, useState, useRef } from 'react';
import { Grid, IconButton, Box, TextField, Autocomplete, Badge, Typography, Snackbar, Alert } from '@mui/material';
import { myApi } from '../../../config/axiosConfig';
import Cookie from 'js-cookie';
import Swal from 'sweetalert2';

// ICONOS
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import DeleteIcon from '@mui/icons-material/Delete';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import ModalDetalles from './modales/ModalDetalles';

const Activos = ({ eventos, indicencias, highAlerts, updateHighAlerts, refresh }) => {

    // =========================================
    // ESTADOS PARA MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);

    const [selected, setSelected] = useState({
        reason_id: null,
        solution: null
    });

    const handleModal = () => {

        setShowModal(!showModal);

    }

    // =========================================
    // FUNCION PARA CERRAR CASO
    // =========================================

    const cerrarCaso = ( event ) => {

        Swal.fire({
            icon: 'question',
            title: 'Desea Cerrar el evento ?',
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Cerrar"
        }).then( async (result) => {

            if(result.isConfirmed){

                try {

                    const payload = {

                        location: event.location,
                        vehicle: event.vehicle,

                    }

                    const response = await myApi.put('/events/close', payload);
        
                    if(response.data){
        
                        Swal.fire({
                            icon: 'success',
                            title: 'Evento cerrado',
                        });

                        refresh();
        
                    }
        
                } catch(e) {
        
                    console.log(e);
        
                }

            }

        })

    }

    const catalogoColores = {

        'HIGH': 'red',
        'MEDIUM': 'orange',
        'LOW': 'blue',

    }

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'vehicle', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) =>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2 }}>
                    
                    <Badge 
                        badgeContent={params.row.total_registros} 
                        color="error"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        sx={{ marginRight: 2 }}
                    />

                    <Typography>{params.row.vehicle}</Typography>

                </Box>
        },
        { 
            field: 'event_type', 
            headerName: 'Incidencia',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'driver', 
            headerName: 'Conductor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'location', 
            headerName: 'Locacion',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'event_date', 
            headerName: 'Fecha',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'reason', 
            headerName: 'Motivo',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.reason || 'PENDIENTE'
        },
        { 
            field: 'severity', 
            headerName: 'Prioridad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => 
                <Box
                    sx={{
                        color: 'white',
                        backgroundColor: params.row.severity !== null ? catalogoColores[params.row.severity] : 'grey',
                    }}
                >
                    {params.row.severity !== null ? params.row.severity : 'PENDIENTE'}
                </Box>
        },
        { 
            field: '', 
            headerName: '',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) =>
                <Box>
                    <a href={params.row.incident_url} target="_blank" rel="noopener noreferrer">
                        <IconButton
                            color='primary'
                        >
                            <GpsFixedIcon />
                        </IconButton>
                    </a>
                    <IconButton
                        onClick={() => {
                            handleModal();
                            setSelected(params.row);
                        }}
                        color='warning'
                    >
                        <BorderColorIcon />
                    </IconButton>
                    {params.row.reason_id !== null && params.row.solution !== null && (
                        <IconButton
                            onClick={() => cerrarCaso(params.row)}
                            color='success'
                        >
                            <BeenhereIcon />
                        </IconButton>
                    )}
                </Box>
        },

    ];

    // =========================================
    // ESTADOS
    // =========================================

    const [unidades, setUnidades] = useState([]);
    const [newEvents, setNewEvents] = useState([]);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState(null);

    // =========================================
    // USE EFFECT
    // =========================================

    useEffect(() => {

        setUnidades([...new Set(eventos.map(evento => evento.vehicle))]);

        if(unidadSeleccionada !== null){

            filtrarEventosPorUnidad(unidadSeleccionada);

        } else {

            setNewEvents(eventos);

        }
        
    }, [eventos]);

    // =========================================
    // FUNCION PARA CAMBIO DE AUTOCOMPLETE
    // =========================================

    const handleChange = (event, newValue) => {

        if(newValue !== null){

            setUnidadSeleccionada(newValue);
            filtrarEventosPorUnidad(newValue);

        } else {

            setUnidadSeleccionada(null);
            setNewEvents(eventos);

        }

    }

    // =========================================
    // FUNCION PARA FILTRAR EVENTOS POR UNIDAD
    // =========================================

    const filtrarEventosPorUnidad = (unidad) => {

        const eventosFiltrados = eventos.filter(evento => evento.vehicle === unidad);

        setNewEvents(eventosFiltrados);

    }

    const audioRef = useRef(null);

    const catalogoAlarmas = {
        jammer: `${process.env.PUBLIC_URL}/alert_sounds/anti_jammer.mp3`,
        gateway: `${process.env.PUBLIC_URL}/alert_sounds/gateway_disconected.mp3`,
        panic: `${process.env.PUBLIC_URL}/alert_sounds/panic_button.mp3`,
        zona_riesgo: `${process.env.PUBLIC_URL}/alert_sounds/zona_riesgo.mp3`
    }

    const normalizeEventType = (eventType) => {
        return (eventType || '')
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    const getAlarmKey = (eventType) => {
        const normalizedEventType = normalizeEventType(eventType);

        if (normalizedEventType.includes('jamm')) return 'jammer';
        if (normalizedEventType.includes('gateway')) return 'gateway';
        if (normalizedEventType.includes('panic')) return 'panic';
        if (normalizedEventType.includes('zona') && normalizedEventType.includes('riesgo')) return 'zona_riesgo';

        return null;
    }

    useEffect(() => {

        if (highAlerts.length === 0) {
            // Si no hay alertas, detén el audio si estaba sonando
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                audioRef.current = null;
            }
            return;
        }

        const alertWithSound = highAlerts.find(alert => getAlarmKey(alert?.event_type));
        const key = getAlarmKey(alertWithSound?.event_type);

        if (key && catalogoAlarmas[key]) {
            // Si ya hay audio sonando, deténlo antes
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }

            const newAudio = new Audio(catalogoAlarmas[key]);
            newAudio.preload = 'auto';
            newAudio.volume = 1;
            //newAudio.loop = true; // Reproduce en bucle
            audioRef.current = newAudio;

            newAudio.play().catch(err => {
                console.warn("Error reproduciendo audio:", {
                    event_type: alertWithSound?.event_type,
                    audio: catalogoAlarmas[key],
                    err
                });
            });
        }

    },[highAlerts]);

    const deleteHighAlerts = ( event_id ) => {

        const newHighAlerts = highAlerts.filter(alert => alert.event_id !== event_id);
        updateHighAlerts(newHighAlerts);

        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current = null;
        }

    }

    // =========================================

    return (

        <Grid container>

            <Box>

                <Autocomplete
                    disablePortal
                    options={unidades}
                    sx={{ width: 300, marginBottom: 2 }}
                    onChange={handleChange}
                    renderInput={(params) => <TextField {...params} label="Unidad" />}
                />

            </Box>

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    data={newEvents}
                />

            </Grid>

            {
                highAlerts.length > 0 && (

                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        open={true}
                        onClose={() => deleteHighAlerts(highAlerts[0].event_id)}
                    >
                        <Alert
                            severity="warning"
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            Alerta ! {highAlerts[0].event_type} detectada !
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={() => deleteHighAlerts(highAlerts[0].event_id)}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Alert>
                    </Snackbar>

                )
            }

            <ModalDetalles
                open={showModal}
                onClose={handleModal}
                refresh={refresh}
                data={selected}
                incidencias={indicencias}
            />

        </Grid>

    )

}

export default Activos
